import { useEffect } from "react";

const PhillRedirect = () => {
  useEffect(() => {
    window.location.href =
      "https://chromewebstore.google.com/detail/kkpdlmjbmkdnkmemngkfaclcldialjig?utm_source=item-share-cb";
  }, []);

  return <div>Redirecting to Phill...</div>;
};

export default PhillRedirect;
